import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var coreColors = {
  ACCENT: 'accent',
  ACTION: 'action',
  BASE: 'base',
  DARK: 'dark',
  DARKER: 'darker',
  ERROR: 'error',
  SUPER: 'super',
  WHITE: 'white',
  WARNING: 'warning'
};
var extendedColors = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
  GREY: 'grey',
  STEELBLUE: 'steelblue',
  HUNTER: 'hunter'
};

var colors = _.assign({}, coreColors, extendedColors);

colors.CORE = _valuesInstanceProperty(_).call(_, coreColors);
colors.EXTENDED = _valuesInstanceProperty(_).call(_, extendedColors);
colors.ALL = _.union(colors.CORE, colors.EXTENDED);
export default colors;
//# sourceMappingURL=colors.js.map